import { InformationalModal } from 'component/modal/informational-modal';
import { TextButton } from 'component/ui/text-button';
import type { VideoVotingChapter } from 'open-modules/zdf/component/videovoting/index';
import { View } from 'react-native';
import { t } from 'util/stdtypes';

type ChapterSelectionModalProps = {
    chapters: VideoVotingChapter[];
    onClose: () => void;
    onSelect: (chapter: VideoVotingChapter) => void;
};

export function ChapterSelectionModal({ chapters, onClose, onSelect }: ChapterSelectionModalProps) {
    return (
        <InformationalModal
            content={
                <View style={{ gap: 8 }}>
                    {chapters.map((chapter) => (
                        <TextButton
                            key={chapter.key}
                            onPress={() => {
                                onSelect(chapter);
                            }}
                            text={chapter.name}
                            variant='primary'
                        />
                    ))}
                </View>
            }
            headingLabel={t('videovoting.select_chapter', 'Select a chapter')}
            onClose={onClose}
        />
    );
}
